import "./Inspiration.module.css";
import Header from "@/reusable_sections/Header";
import PartnerInGroundAndConstruction from "./sections/PartnerInGroundAndConstruction";
import WetRoomsWalkInShowersGallery from "./sections/WetRoomsWalkInShowersGallery";
import SmartPlaneringBadrum from "./sections/SmartPlaneringBadrum";
import MaterialFargerDetaljer from "./sections/MaterialFargerDetaljer";
import BelysningOchDetaljer from "./sections/BelysningOchDetaljer";
import VarmlandLokalt from "./sections/VarmlandLokalt";
import Marchi from "./sections/Marchi";
import BookFreeVisit from "./sections/BookFreeVisit";
import Footer from "@/reusable_sections/Footer";
export default function InspirationPage() {
  return <div>
      <Header />
      <PartnerInGroundAndConstruction />
      <WetRoomsWalkInShowersGallery />
      <SmartPlaneringBadrum />
      <MaterialFargerDetaljer />
      <BelysningOchDetaljer />
      <VarmlandLokalt />
      
      <BookFreeVisit />
      <Footer />
    </div>;
}